import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RequestServies from "../../../services/RequestServices";
import WaterServices from "../../../services/WaterServices";
import MivForm from "../Miv/MivForm";
import Select from "react-select";

const AddMivWaterUsedItem = ({ onSuccess }) => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [originalEligibleMap, setOriginalEligibleMap] = useState({});

  // New form fields state
  const [inTime, setInTime] = useState("");
  const [outTime, setOutTime] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");

  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [mivList, setMivList] = useState([]);
  const [selectedMiv, setSelectedMiv] = useState("");

  const [mrvList, setMrvList] = useState([]);
  const [selectedMrv, setSelectedMrv] = useState("");

  const [items, setItems] = useState([
    { name: "", inventory: "", description: "", currentQty: "", usedQty: "", error: "", unit: "", eligible: "" },
  ]);

  const [run, setRun] = useState(0);
  const [partOptions, setPartOptions] = useState([]);

  const handleStoreChange = (e) => {
    const storeId = e.target.value;
    setSelectedStore(storeId);
    setSelectedMiv("");
    setSelectedMrv("");
    setMrvList([]);          // Clear MRV List immediately
    setPartOptions([]);      // Clear part options immediately
    setItems([getEmptyItem()]);

    fetchMrvList(storeId);
    fetchMivList(storeId);   // Ensure both lists fetched together
  };



  const fetchMivList = (storeId) => {
    if (!storeId) return;
    RequestServies.getMiv(storeId, "open")
      .then((res) => {
        const data = res?.data?.data || [];
        setMivList(data);
        setSelectedMiv(data.length > 0 ? data[0]._id : "");
      })
      .catch(() => {
        setMivList([]);
        setSelectedMiv("");
      });
  };

  const fetchMrvList = (storeId) => {
    if (!storeId) return;

    WaterServices.getMRV(storeId)
      .then((res) => {
        const data = Array.isArray(res?.items) ? res.items : [];
        setMrvList(data);

        const defaultMrvId = data.length > 0 ? data[0]?.mrv?._id : "";

        setSelectedMrv(defaultMrvId);

        // ✅ Call handleMrvChange immediately after setting selectedMrv
        if (defaultMrvId) {
          handleMrvChange({ target: { value: defaultMrvId } });
        }
      })
      .catch(() => {
        setMrvList([]);
        setSelectedMrv("");
      });
  };


  useEffect(() => {
    if (selectedStore) {
      fetchMivList(selectedStore);
      fetchMrvList(selectedStore);

      setItems([
        {
          name: "",
          inventory: "",
          description: "",
          currentQty: "",
          usedQty: "",
          error: "",
          unit: "",
          eligible: "",
        },
      ]);
    }
  }, [selectedStore, run]);




  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems.length ? newItems : [{ name: "", inventory: "", description: "", currentQty: "", usedQty: "", error: "", unit: "", eligible: "" }]);
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...items];

    // Type conversion
    const parsedValue = ["usedQty", "currentQty", "eligible"].includes(field)
      ? value === "" ? "" : Number(value)
      : value;

    newItems[index][field] = parsedValue;

    if (field === "usedQty") {
      const usedQty = Number(value);
      if (value === "" || usedQty <= 0) {
        newItems[index].error = "Used Qty cannot be 0 or negative";
      } else if (usedQty > newItems[index].eligible) {
        newItems[index].error = "Used Qty cannot be greater than Eligible Qty";
      } else {
        newItems[index].error = "";
      }
    }

    setItems(newItems);
  };




  const handleAddItem = (e) => {
    e.preventDefault();

    const lastItem = items[items.length - 1];

    // New required field checks
    if (!supplierName || !invoiceNo || !vehicleNo || !inTime || !outTime) {
      Swal.fire({
        icon: "warning",
        title: "Missing Header Details",
        text: "Please fill all required details: Supplier Name, Invoice No, Vehicle No, In Time, and Out Time.",
      });
      return;
    }

    // Last item validation
    if (
      !lastItem.inventory ||
      !lastItem.usedQty ||
      lastItem.usedQty <= 0 ||
      lastItem.usedQty > lastItem.eligible ||
      lastItem.error
    ) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Item",
        text: "Please complete the last item before adding a new one. Ensure Part No is selected, Used Qty is valid, and no validation errors.",
      });
      return;
    }

    // ✅ All validations passed — add new row
    setItems([...items, getEmptyItem()]);
  };





  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;
    let errorMessage = "";

    items.forEach((item, index) => {
      if (!item.usedQty || item.usedQty <= 0) {
        isValid = false;
        errorMessage = `Item ${index + 1}: Used Qty cannot be 0 or negative`;
      } else if (item.usedQty > item.eligible) {
        isValid = false;
        errorMessage = `Item ${index + 1}: Used Qty exceeds eligible quantity`;
      }
    });

    if (!selectedMiv) {
      isValid = false;
      errorMessage = "MIV not selected!";
    }
    if (!supplierName) {
      isValid = false;
      errorMessage = "Supplier Name is required.";
    }
    if (!invoiceNo) {
      isValid = false;
      errorMessage = "Invoice/Challan No is required.";
    }
    if (!vehicleNo) {
      isValid = false;
      errorMessage = "Vehicle No is required.";
    }

    if (!isValid) {
      Swal.fire({ icon: "error", title: "Validation Error", text: errorMessage });
      return;
    }

    setIsSubmitting(true);

    const requestData = {
      mivId: selectedMiv,
      mrvId: selectedMrv,
      supplierName,
      invoiceNo,
      vehicleNo,
      inTime,
      outTime,
      items,
    };

    RequestServies.submitwaterMiv(requestData)
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Submitted",
          text: "MIV Items submitted successfully!",
        });
        setItems([{ name: "", inventory: "", description: "", currentQty: "", usedQty: "", error: "", unit: "", eligible: "" }]);
        setRun((prev) => prev + 1);
        if (onSuccess) onSuccess();
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Failed", text: "Error occurred while submitting!" });
      })
      .finally(() => setIsSubmitting(false));
  };


  const handleMrvChange = (e) => {
    const mrvId = e.target.value;
    setSelectedMrv(mrvId);

    if (!selectedStore || !mrvId) {
      setItems([getEmptyItem()]);
      return;
    }

    WaterServices.getItemsForMRV(selectedStore, mrvId)
      .then((res) => {
        const data = Array.isArray(res?.data?.items) ? res.data.items : [];

        const options = data.map((item) => ({
          label: `${item?.inventory?.masterItem?.partNo} - ${item?.inventory?.masterItem?.description}`,
          value: item?.inventory?._id,
          inventoryData: item,
        }));
        setPartOptions(options);

        const mapEligible = {};
        data.forEach(item => {
          const inventoryId = item.inventory._id;
          const eligibleQty = Number(item.qtyRequired || 0);  // ✅ ensure number
          mapEligible[inventoryId] = eligibleQty;
        });

        setOriginalEligibleMap(mapEligible);  // ✅ Must set before using in state items

        const mappedItems = data.map((item) => ({
          inventory: item?.inventory?._id || "",
          description: item?.inventory?.masterItem?.description || "",
          currentQty: item?.inventory?.currentStock || "",
          usedQty: "",
          error: "",
          unit: item?.inventory?.masterItem?.unit?.name || "",
          eligible: Number(item?.qtyRequired || 0), // ✅ ensure number
        }));

        setItems(mappedItems.length ? mappedItems : [getEmptyItem()]);
      })
      .catch(() => {
        setItems([getEmptyItem()]);
        setPartOptions([]);
      });
  };



  const getEmptyItem = () => ({
    name: "",
    inventory: "",
    description: "",
    currentQty: "",
    usedQty: "",
    error: "",
    unit: "",
    eligible: 0, // Change from "" to 0
  });



  const handlePartSelect = (index, selectedOption) => {
    const selectedItem = selectedOption?.inventoryData;
    const inventoryId = selectedOption.value;
    const originalEligibleQty = originalEligibleMap[inventoryId] || 0;

    // Calculate sum of usedQty for this inventory in all rows except the current one
    const usedQtySum = items.reduce((sum, item, i) => {
      if (i !== index && item.inventory === inventoryId && item.usedQty) {
        return sum + Number(item.usedQty);
      }
      return sum;
    }, 0);


    const remainingEligible = Math.max(originalEligibleQty - usedQtySum, 0);

    setItems((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index] = {
        ...updatedItems[index],
        inventory: inventoryId,
        description: selectedItem?.inventory?.masterItem?.description || "",
        currentQty: selectedItem?.inventory?.currentStock || "",
        unit: selectedItem?.inventory?.masterItem?.unit?.name || "",
        eligible: remainingEligible,
        usedQty: "",
        error: "",
      };
      return updatedItems;
    });
  };


  return (
    <>
      <MivForm show={isModelOpen} handleClose={() => setIsModelOpen(false)} store={stores} onSuccess={() => setRun((prev) => prev + 1)} />

      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">

            {/* Filter Header */}
            <div className="content-title d-flex justify-content-between align-items-center">
              <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
              <div className="tools">
                <Link to="#" onClick={() => setOpen(!open)}>
                  <i className={`fas fa-angle-${open ? "up" : "down"}`}></i>
                </Link>
              </div>
            </div>

            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3">
                      <label>Select Store</label>
                      <select className="form-select" value={selectedStore} onChange={handleStoreChange}>
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>{store.name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-xl-3">
                      <label>Select Material Issue Voucher No.</label>
                      <select className="form-select" value={selectedMiv} onChange={(e) => setSelectedMiv(e.target.value)}>
                        {mivList.length ? mivList.map(miv => (
                          <option key={miv._id} value={miv._id}>{miv.mivNo}</option>
                        )) : <option disabled>No MIV Found</option>}
                      </select>
                    </div>

                    <div className="col-xl-3">
                      <label>Select MRV No.</label>
                      <select className="form-select" value={selectedMrv} onChange={handleMrvChange}>
                        {mrvList.length ? mrvList.map(mrv => (
                          <option key={mrv?.mrv?._id} value={mrv?.mrv?._id}>{mrv?.mrv?.mrvNo}</option>
                        )) : <option disabled>No MRV Found</option>}
                      </select>
                    </div>

                    <div className="col-xl-3 d-flex align-items-end">
                      <button className="btn btn-sm btn-primary w-100" onClick={() => setIsModelOpen(true)}>Generate New MIV No.</button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>

            {/* MIV Item Form */}
            <div className="filter cm-content-box box-primary mt-3">
              <div className="content-title d-flex justify-content-between align-items-center">
                <div className="cpa"><i className="fa fa-plus me-2" />Add MIV Item</div>
                <div className="tools">
                  <Link to="#" onClick={() => setOpen2(!open2)}>
                    <i className={`fas fa-angle-${open2 ? "up" : "down"}`}></i>
                  </Link>
                </div>
              </div>

              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <form>
                        {items.map((item, index) => (
                          <div key={index} className="row align-items-end">
                            <div className="col-md-2 mb-2">
                              <label>Select Part No</label>
                              <Select
                                options={partOptions} // You must prepare this using MRV data
                                value={partOptions.find(opt => opt.value === item.inventory)}
                                onChange={(selectedOption) => handlePartSelect(index, selectedOption)}
                                placeholder="Select Part No"
                                menuPortalTarget={document.body}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '30px',
                                    fontSize: '12px',
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  option: (base) => ({
                                    ...base,
                                    fontSize: '12px',
                                  }),
                                }}
                              />
                            </div>
                            <div className="col-md-2 mb-2">
                              <label>Description</label>
                              <input type="text" className="form-control form-control-sm" value={item?.description} readOnly />
                            </div>
                            <div className="col-md-2 mb-2">
                              <label>{item?.inventory?.masterItem?.unit?.name ? `Current (${item?.unit})` : "Current Qty"}</label>
                              <input type="text" className="form-control form-control-sm" value={item?.currentQty} readOnly />
                            </div>
                            <div className="col-md-2 mb-2">
                              <label>{item?.unit ? `Eligible (${item?.unit})` : "Eligible Qty"}</label>
                              <input type="text" className="form-control form-control-sm" value={item?.eligible} readOnly />
                            </div>
                            <div className="col-md-2 mb-2">
                              <label>{item.unit ? `Used (${item.unit})` : "Used Qty"}</label>
                              <input type="number"
                                className="form-control form-control-sm"
                                min="0"
                                value={item.usedQty}
                                disabled={!Number(item.eligible)}
                                onChange={(e) => handleItemChange(index, "usedQty", e.target.value)} />
                              <p className="text-danger">{item.error}</p>
                            </div>
                            <div className="col-md-2 mb-2">
                              <label>In Time</label>
                              <input
                                type="time"
                                className="form-control form-control-sm"
                                value={inTime}
                                onChange={(e) => setInTime(e.target.value)}
                              />
                            </div>
                            <div className="col-md-2 mb-2">
                              <label>Out Time</label>
                              <input
                                type="time"
                                className="form-control form-control-sm"
                                value={outTime}
                                onChange={(e) => setOutTime(e.target.value)}
                              />
                            </div>
                            <div className="col-md-2 mb-2">
                              <label>Supplier Name</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={supplierName}
                                onChange={(e) => setSupplierName(e.target.value)}
                              />
                            </div>
                            <div className="col-md-2 mb-2">
                              <label>Invoice / Challan No</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={invoiceNo}
                                onChange={(e) => setInvoiceNo(e.target.value)}
                              />
                            </div>
                            <div className="col-md-2 mb-2">
                              <label>Vehicle No</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={vehicleNo}
                                onChange={(e) => setVehicleNo(e.target.value)}
                              />
                            </div>
                            <div className="col-md-2 mb-2 d-flex align-items-end">
                              <button className="btn btn-danger btn-xs sharp" type="button" onClick={(e) => handleRemoveItem(e, index)}><i className="fa fa-trash" /></button>
                            </div>
                          </div>
                        ))}
                        <div className="row mt-3 mb-3">
                          <div className="col-md-2">
                            <button className="btn btn-sm btn-primary" type="button" onClick={handleAddItem}>Add Item</button>
                          </div>
                          <div className="col-md-2">
                            <button className="btn btn-sm btn-primary" type="button" onClick={handleSubmit} disabled={isSubmitting}>
                              {isSubmitting ? "Submitting..." : "Submit"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMivWaterUsedItem;
